/* eslint-disable react/jsx-props-no-spreading */
import { FC, useMemo } from 'react'
import { Card, Spin } from 'antd'
import { Pie } from '@ant-design/plots'
import beautifulPieConfig from 'utils/pieConfigBuilder'
import { useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'

const config = beautifulPieConfig<number>({
	contentHint(data) {
		return data.reduce((sum, curr) => sum + curr.value, 0).toString()
	},
})
	.origin({})
	.size({
		height: 250,
	})

const BroadcastMetrics: FC = () => {
	const { insights, insightsLoading: loading } = useAppSelector(
		state => state.broadcasts,
		isEqual
	)

	const data = useMemo(
		() => [
			{
				type: 'Sent',
				value: insights?.sendCount ?? 0,
			},
			{
				type: 'Delivered',
				value: insights?.deliveredCount ?? 0,
			},
			{
				type: 'Actions',
				value: insights?.replies ?? 0,
			},
			{
				type: 'Enquiry',
				value: insights?.enquiry ?? 0,
			},
			{
				type: 'Read',
				value: insights?.readCount ?? 0,
			},
			{
				type: 'Failed',
				value: insights?.failedCount ?? 0,
			},
		],
		[insights]
	)

	return (
		<Spin spinning={loading}>
			<Card title='Broadcast Metrics'>
				<Pie {...config.data(data).build()} />
			</Card>
		</Spin>
	)
}

export default BroadcastMetrics
